import { create } from 'zustand'

/**
 * Session expiry UI state — AU-MM Epic.
 *
 * 책임: access token 만료 감지 시 SessionExpiredModal 표시 트리거.
 *
 * 트리거 경로: `apiClient` 가 인증 필요 엔드포인트에서 401 응답을 받으면
 * `setExpired(true)` 를 호출. AppShell 이 이를 구독하여 모달을 띄운다.
 *
 * Phase 1: expired-only. Phase 2 에서 backend 토큰 만료 시각 노출 후
 * warning(만료 임박) variant 까지 확장 예정.
 */

interface SessionState {
  isExpired: boolean
  setExpired: (expired: boolean) => void
  reset: () => void
}

export const useSessionStore = create<SessionState>((set) => ({
  isExpired: false,
  // Idempotent — apiClient 가 동시 401 100건을 받아 setExpired(true) 를 100회
  // 호출해도 Zustand 가 같은 값 set 일 때 re-render 트리거 안 함 + state 변화
  // 없음. SessionExpiredModal 은 isExpired===true 단일 부울만 구독 → 다중 호출
  // 안전. (/qa 5/22 검토 R1 — refresh 실패 동시성 시나리오 검증)
  setExpired: (expired) => set({ isExpired: expired }),
  reset: () => set({ isExpired: false }),
}))
